import { colors, createTheme } from "@mui/material";
import { thTH } from "@mui/material/locale";

import typography from "./typography";

const theme = createTheme(
  {
    palette: {
      background: {
        default: "#f5f5f5",
        paper: colors.common.white,
      },
      primary: {
        contrastText: "#ffffff",
        main: "#6326a0",
      },
      text: {
        primary: "#172b4d",
        secondary: "#6b778c",
      },
    },
    typography,
  },
  thTH
);

export default theme;
